import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';

/**
 * Komponen ini mengecek status login dan role user,
 * lalu redirect ke dashboard sesuai peran.
 */
const AuthRedirector = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate('/login');
        return;
      }
      // Ambil role user dari Firestore
      const userRef = doc(db, 'users', user.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const { role, approved } = userSnap.data();
        // Check the 'approved' field leniently (boolean true or string "true")
        if (!(approved === true || approved === "true")) {
          alert('Akun Anda belum disetujui admin.');
          // Logout user
          await auth.signOut();
          navigate('/login');
          return;
        }
        // Redirect all approved users to the unified dashboard
        if (role === 'admin' || role === 'laboran' || role === 'mahasiswa' || role === 'dosen') {
          navigate('/dashboard');
        } else {
          // If role is unknown or not set, redirect to login
          console.warn(`Unknown or missing role: ${role}. Redirecting to login.`);
          navigate('/login');
        }
      } else {
        // User document doesn't exist in Firestore
        console.error(`User document not found for UID: ${user.uid}. Redirecting to login.`);
        navigate('/login');
      }
    });
    return () => unsub();
  }, [navigate]);

  return <div>Memeriksa status login...</div>;
};

export default AuthRedirector;
